
export default{
    // @Business
    newCreatedBusiness: {},
}